"use client";

import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import cn from "clsx";
import DegreeProgramCard from "@molecules/DegreeProgramCard/DegreeProgramCard";
import {  useEffect, useState } from "react";
import Button from "@/components/atoms/Button";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import { usePathname } from "next/navigation";

export default function DegreeProgramsSection({
  programs,
  enabled,
  text,
  isNotClickable = false,
}) {
  if (!enabled) return null;
  const pathname=usePathname();
  const isNewLanding= pathname.includes("/lp-nw/brand");

  const [activeProgramType, setActiveProgramType] = useState("UG_Program");
  const [programsList, setProgramsList] = useState(programs);
  const [isListOpen, setIsListOpen] = useState(false);

  const setPrograms = (isFullList: boolean) => {
    if (isFullList) {
      setProgramsList(
        programs?.filter(
          (x) => x?.attributes?.BasicDetails?.ProgramType === activeProgramType
        ) || []
      );
      setIsListOpen(true);
    } else {
      setProgramsList(
        programs
          ?.filter(
            (x) =>
              x?.attributes?.BasicDetails?.ProgramType === activeProgramType
          )
          ?.slice(0, isNewLanding?20:6) || []
      );
      setIsListOpen(false);
    }
  };

  useEffect(() => {
    setPrograms(false);
  }, [activeProgramType]);

  return (
    <div className={cn("container", styles.mainContainer)}>
      <div className={styles.root}>
        <div className={styles.titleContainer}>
          <Markdown className={styles.title}>{text}</Markdown>

          <div className={styles.btnContainer}>
            <button
              className={cn(styles.btn, {
                [styles.selectedBtn]: activeProgramType === "UG_Program",
              })}
              onClick={() => {
                setActiveProgramType("UG_Program");
                pushToDataLayer({
                  event: "explore_online_programs_cta_interaction",
                  cta_text: "UG Program",
                  section_name: text.replaceAll("_","") || "NA",
                  page_type: getGlobalStateValue('pageType')  || "Home Page",
                });
              }}
            >
              UG Program
            </button>
            <button
              className={cn(styles.btn, {
                [styles.selectedBtn]: activeProgramType === "PG_Program",
              })}
              onClick={() => {
                setActiveProgramType("PG_Program")
                pushToDataLayer({
                  event: "explore_online_programs_cta_interaction",
                  cta_text: "PG Program",
                  section_name: text.replaceAll("_","") || "NA",
                  page_type: getGlobalStateValue('pageType')  || "Home Page",
                });
              }}
            >
              PG Program
            </button>
          </div>
        </div>

        {/* Program cards */}
        <div className={styles.cardsContainer}>
          {programsList
            ?.filter((x) => x?.attributes?.BasicDetails?.enabled)
            ?.map((item, i) => (
              <DegreeProgramCard
                key={i}
                {...item?.attributes?.BasicDetails}
                scroll={true}
                isNotClickable={isNotClickable}
              />
            ))}
        </div>

        {programsList?.length > (isNewLanding?20:6) ? (
          <Button
            buttonProps={{ onClick: () => setPrograms(!isListOpen) }}
            className={styles.showMoreBtn}
            type="submit"
            icon={
              isListOpen ? "/_a/icons/arrow-up.svg" : "/_a/icons/arrow-down.svg"
            }
            hoverIcon={
              isListOpen
                ? "/_a/icons/arrow-up-white.svg"
                : "/_a/icons/arrow-down-white.svg"
            }
            bg="o"
            color="b"
          >
            {isListOpen ? "see less" : "see more"}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
